'use client'

import { captureError } from '@/shared/utils/errorUtils'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
    useEffect(() => {
        captureError(error)
    }, [error])

    return (
        <html>
            <body>
                <NextError statusCode={0} />
            </body>
        </html>
    )
}
